<form [formGroup]="addressForm" (ngSubmit)="submitForm()">
  <div class="md:flex md:gap-4 md:mb-8">
    <p-floatlabel class="w-full md:w-2/3 mb-8 md:mb-0">
      <input [id]="id + 'logradouro'" pInputText type="text" formControlName="street"
        [pTooltip]="formWatched['children']['street']() | formFieldFeedback" tooltipEvent="focus"
        tooltipPosition="bottom" required class="w-full" />
      <label [for]="id + 'logradouro'">Logradouro</label>
    </p-floatlabel>
    <p-floatlabel class="w-full md:w-1/3 mb-8 md:mb-0">
      <input [id]="id + 'numero'" pInputText type="text" formControlName="number"
        [pTooltip]="formWatched['children']['number']() | formFieldFeedback" tooltipEvent="focus"
        tooltipPosition="bottom" required class="w-full" />
      <label [for]="id + 'numero'">Número</label>

    </p-floatlabel>
  </div>
  <div class="md:flex md:gap-4 md:mb-8">
    <p-floatlabel class="w-full md:w-2/3 mb-8 md:mb-0">
      <input [id]="id + 'bairro'" pInputText type="text" formControlName="neighborhood"
        [pTooltip]="formWatched['children']['neighborhood']() | formFieldFeedback" tooltipEvent="focus"
        tooltipPosition="bottom" required class="w-full" />
      <label [for]="id + 'bairro'">Bairro</label>
    </p-floatlabel>

    <div class="w-full md:w-1/3 mb-8 md:mb-0">
      <p-floatlabel class="w-full">
        <p-inputmask id="id + 'cep'" (focusout)="onFetchAndFillFromZipCode()" type="text" mask="99999-999"
          [pTooltip]="formWatched['children']['zipCode']() | formFieldFeedback" tooltipEvent="focus"
          tooltipPosition="bottom" slotChar="" formControlName="zipCode" required />
        <label [for]="id + 'cep'">CEP</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="mb-8 md:mb-8">
    <p-floatlabel class="w-full">
      <input [id]="id + 'complemento'" pInputText type="text" formControlName="complement"
        [pTooltip]="formWatched['children']['complement']() | formFieldFeedback" tooltipEvent="focus"
        tooltipPosition="bottom" required class="w-full" />
      <label [for]="id + 'complemento'">Complemento</label>
    </p-floatlabel>
  </div>
  <div class="md:flex md:gap-4 md:mb-8">
    <p-floatlabel class="w-full md:w-3/4 mb-8 md:mb-0">
      <input [id]="id + 'cidade'" pInputText type="text" formControlName="city"
        [pTooltip]="formWatched['children']['city']() | formFieldFeedback" tooltipEvent="focus" tooltipPosition="bottom"
        required class="w-full" />
      <label [for]="id + 'cidade'">Cidade</label>
    </p-floatlabel>
    <p-floatlabel class="w-full md:w-1/4 mb-8 md:mb-0">
      <input [id]="id + 'estado'" pInputText type="text" formControlName="state"
        [pTooltip]="formWatched['children']['state']() | formFieldFeedback" tooltipEvent="focus"
        tooltipPosition="bottom" required class="w-full" />
      <label [for]="id + 'estado'">Estado</label>
    </p-floatlabel>

  </div>
  <p-button styleClass="w-full mb-4 font-semibold" [loading]="isLoading()" [disabled]="isLoading() || !enabled()"
    type="submit" [label]="initialData() ? 'Atualizar' : 'Cadastrar'" />
</form>